module.exports = __webpack_public_path__ + "static/media/frame12.80fae0db.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/frame-top/frame12.png
// module id = 71
// module chunks = 0